<template>
  <div class="appSearchInputBox-wrapper" v-click-outside="onClickOutSide">
    <q-input
      outlined
      v-model="searchInputBoxString"
      placeholder="Search by Name, Item Number or Keyword"
      dense
      rounded
      @update:model-value="onInputValueChange"
      class="appSearchInputBox"
      @keyup.enter="onClickSearchBtn"
      input-class="appSearchInput"
      @focus="onSearchInputFocus"
      bg-color='white'
    >
      <template v-slot:append>
        <q-btn round dense flat color="appSearchInputBox" class="bg-appSearchInputBox btn-appSearchInputBox"
          @click="onClickSearchBtn" icon="search" />
      </template>
    </q-input>
    <Teleport to="body">
      <SearchResultsWindow v-if="showSearchResultsWindow" v-click-outside="onClickOutSide" :searchInputBoxString="searchInputBoxString"></SearchResultsWindow>
    </Teleport>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from 'vue';
import { useSearchStore } from '../../stores/search-store.js';
import { useDropdownSearchStore } from '../../stores/dropdown-search-store.js';
import { useCategoryStore } from '../../stores/category-store.js'
import { useFilterStore } from '../../stores/filter-store.js'
import { storeToRefs } from 'pinia';
import SearchResultsWindow from './SearchResultsWindow.vue';

const { searchedString,isDropDownSearch } = storeToRefs(useSearchStore());
const { isGenericSearch } = storeToRefs(useFilterStore());

const dropdownSearchStore = useDropdownSearchStore();
const { dropdownSearchProducts } = dropdownSearchStore;

const categoryStore = useCategoryStore();
const { loadAllCategoryDetails } = categoryStore;

const { searchArticles, searchProducts, debounce, searchFeedBack, setLoading, unSetLoading } = useSearchStore();

const searchInputBoxString = ref('');
const showSearchResultsWindow = ref(false);

const onInputValueChange =  debounce(async(value) => {
  if (searchInputBoxString.value.length >= 3) {
    searchedString.value = searchInputBoxString.value;
    isDropDownSearch.value=true;
    // await searchDropdownArticles();
    setLoading();
    await searchArticles();
    await searchFeedBack();
    // await dropdownSearchProducts();
    unSetLoading();
    showSearchResultsWindow.value = true;
  }
},200);

const onClickSearchBtn = () => {
  if (searchInputBoxString.value.length >= 3) {
    searchedString.value = searchInputBoxString.value;
    isDropDownSearch.value = false;
    if (isGenericSearch.value === true) {
      searchProducts()
      searchArticles()
      showSearchResultsWindow.value = false;
    }
    else {
      document.location.href = '/search?q=' + searchInputBoxString.value;
    }
  }
};

const onSearchInputFocus = () => {
  showSearchResultsWindow.value = searchInputBoxString.value.length >= 3 ? true : false
  if (showSearchResultsWindow.value === true) {
      searchFeedBack();
  }
}
const onClickOutSide = (event, el) => {
  if (!(document.getElementsByClassName('v-search-result-window')[0] == undefined || document.getElementsByClassName('v-search-result-window')[0] === el || document.getElementsByClassName('v-search-result-window')[0].contains(event.target))) {
    showSearchResultsWindow.value = false;
  }
}

onMounted(() => {
  loadAllCategoryDetails();
})

</script>

<style lang="scss" scoped>
.appSearchInputBox {
  width: inherit;
}

.q-field :deep(.q-field__control) {
  padding-right: 5px !important;
  padding-left: 17px !important;
  height: 43px !important;
}

.appSearchInputBox :deep(.appSearchInput) {
  font-size: 16px !important;
  line-height: 22px !important;
  letter-spacing: 0.5px !important;
  color: #645454 !important;
}

.appSearchInputBox :deep(.appSearchInput:placeholder-shown) {
  color: #b9b9b9;
  font-size: 18px;
}

.appSearchInputBox :deep(.btn-appSearchInputBox) {
  margin-top: 2px !important;
}

.appSearchInputBox-wrapper {
  position: relative;
}
</style>
